import React from "react";
import { Button, Card, Dropdown, Image, Modal } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import EmployeeUpdateStatusBtn from "../buttons/EmployeeUpdateStatusBtn";
import EmployeeDetails from "../buttons/EmployeeDetailsBtn";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { useStore } from "../../../app/stores/store";
import UpdateEmployeeDetails from "../modal/UpdateEmployeeDetails";
import UpdatePersonalInfoForm from "../editInformationsForms/UpdatePersonalInfoForm";
import EmployeeStatus from "../status/EmployeeStatus";
import UpdatePhysicalInfoForm from "../editInformationsForms/UpdatePhysicalInfoForm";
import UpdateSkillsInfoForm from "../editInformationsForms/UpdateSkillsInfoForm";
import UpdateEmploymentInfoForm from "../editInformationsForms/UpdateEmploymentInfoForm";
import UpdateSalaryInfoForm from "../editInformationsForms/UpdateSalaryInfoForm";
import SuspendEmployee from "../status/SuspendEmployee";
import { useEmployee } from "../../../app/hooks/useEmployee";

const EmployeeCards = (props) => {
  EmployeeCards.propTypes = {
    data: PropTypes.node.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };
  const { data, onSubmit } = props;
  const { modalStore, updateEmployeeStore } = useStore();

    const {
      mutate,
    } = useEmployee();
  const {
    updateEmployeeDetails,
    setUpdateEmployeeDetailsModalVisible,
    updatePersonalInfoModal,
    setUpdatePersonalInfoModalVisible,
    updatePhysicalInfoModal,
    setUpdatePhysicalInfoModalVisible,
    updateSkillsInfoModal,
    setUpdateSkillsInfoModalVisible,
    updateEmploymentInforModal,
    setUpdateEmploymentInfoModalVisible,
    setUpdateSalaryInfoModalVisible,
    updateSalaryInforModal,
    updateStatusModal,
    suspendFormModal,
    setUpdateStatusModalVisible,
    setSuspendFormModalVisible,
  } = modalStore;
  const { setGetEmployeeId, deleteEmployeeById } = updateEmployeeStore;
  //const {data} = useQuery('employeesList', fetchEmployees);

  // const items = [
  //   {
  //     label: <p href="#">EDIT INFO</p>,
  //   },
  //   {
  //     type: "divider",
  //   },
  //   {
  //     label: <p href="#">DELETE</p>,
  //   },
  // ];

  const handleCancel = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdateStatusModalVisible(false);
  };
  const handleSuspendStatusUpdate = () => {
    setSuspendFormModalVisible(false);
  };

  const handleCancelPersonalInfoModal = () => {
    setUpdatePersonalInfoModalVisible(false);
  };

  const handleCancelPhysicalInfoModal = () => {
    setUpdatePhysicalInfoModalVisible(false);
  };

  const handleCancelSkillsInfoModal = () => {
    setUpdateSkillsInfoModalVisible(false);
  };

  const handleCancelEmploymentInfoModal = () => {
    setUpdateEmploymentInfoModalVisible(false);
  };

  const handleCancelSalaryInfoModal = () => {
    setUpdateSalaryInfoModalVisible(false);
  };

  const handleOk = () => {
    setUpdateStatusModalVisible(false);
  };

  // const handleDropdownClick = (index, values) => {
  //   // Perform any other actions you need based on the index and values.id
  //   setUpdateEmployeeDetailsModalVisible(true);
  //   //setPersonalInfo(values);
  //   setGetEmployeeId(values?.employeePersonalProfile?.employeeId);
  // };

  const showDeleteConfirm = (employee) => {
    Modal.confirm({
      title: `Are you sure you want to delete ${employee.firstName} ${employee.lastName}?`,
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      onOk() {
        deleteEmployeeById(employee);
        mutate();
      },
    });
  };
  

  const getDropdownItems = (index, values) => [
    {
      label: <p>EDIT INFO</p>,
      key: "edit",
      onClick: () => {
        setUpdateEmployeeDetailsModalVisible(true);
        setGetEmployeeId(values?.employeePersonalProfile?.employeeId);
      },
    },
    {
      type: "divider",
    },
    {
      label: <p style={{ color: "red" }}>Delete</p>,
      key: "delete",
      onClick: () => showDeleteConfirm(values?.employeePersonalProfile?.employeeId),
    },
  
  ];
  

  return (
    <>
      {data?.length === 0 ? (
        <div style={{ textAlign: "center" }}>
          <p>No data in the list</p>
        </div>
      ) : (
        <>
          <div
            id="scrollableDiv"
            style={{
              height: 550,
              overflow: "auto",
              display: "flex",
              flexDirection: "column-reverse",
            }}
          >
            <InfiniteScroll
              dataLength={Array.isArray(data) ? data.length : 0}
              //next={this.fetchMoreData}
              style={{ display: "flex", flexDirection: "column-reverse" }} //To put endMessage and loader to the top.
              inverse={true} //
              hasMore={true}
              //loader={<h4>Loading...</h4>}
              scrollableTarget="scrollableDiv"
            >
              <div className="employeeCardsContainer">
                <React.Fragment key={1}>
                  {data?.map((values, index) => {
                    return (
                      <Card className="employeesCard" key={index}>
                        <div className="cards">
                          <Image
                            preview={false}
                            width={100}
                            height={100}
                            src={values?.profileImagePath}
                            fallback="data:image/png;base64,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"
                          />
                          <div className="cardsInfo">
                            <p className="cardName">
                              {values.firstName} {values.lastName}
                            </p>
                            <p className="cardPosition">
                              {values.serviceRecords?.[0]?.positionName}
                            </p>
                          </div>
                          <Dropdown
                            menu={{
                              items: getDropdownItems(index, values),

                            }}
                            className="dropdownBtn"
                            trigger={["click"]}
                          >
                            <Button>
                              <EllipsisOutlined className="dropdownIcon" />
                            </Button>
                          </Dropdown>
                          <EmployeeUpdateStatusBtn
                            status={
                              values.serviceRecords?.[0]?.employmentStatus
                            }
                            id={values?.id}
                          />
                          <EmployeeDetails
                            id={values?.id}
                            onSubmit={onSubmit}
                          />
                        </div>
                      </Card>
                    );
                  })}
                </React.Fragment>
                {/* {hasNextPage && (
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                onClick={fetchNextPage}
                disabled={isFetching}
              >
                {isFetching ? "Loading..." : "Next Page"}
              </Button>
            </div>
          )}
          {isError && !isFetching && !hasNextPage && (
            <div style={{ textAlign: "center" }}>
              <p>No data in the list</p>
            </div>
          )} */}
              </div>
            </InfiniteScroll>
          </div>
        </>
      )}
      <Modal
        open={updateEmployeeDetails}
        onCancel={handleCancel}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdateEmployeeDetails />
      </Modal>
      <Modal
        open={updatePersonalInfoModal}
        onCancel={handleCancelPersonalInfoModal}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdatePersonalInfoForm onSubmit={onSubmit} />
      </Modal>
      <Modal
        open={updatePhysicalInfoModal}
        onCancel={handleCancelPhysicalInfoModal}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdatePhysicalInfoForm onSubmit={onSubmit} />
      </Modal>
      <Modal
        open={updateSkillsInfoModal}
        onCancel={handleCancelSkillsInfoModal}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdateSkillsInfoForm onSubmit={onSubmit} />
      </Modal>
      <Modal
        open={updateEmploymentInforModal}
        onCancel={handleCancelEmploymentInfoModal}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdateEmploymentInfoForm onSubmit={onSubmit} />
      </Modal>
      <Modal
        open={updateSalaryInforModal}
        onCancel={handleCancelSalaryInfoModal}
        footer={null}
        width={800}
        destroyOnClose
      >
        <UpdateSalaryInfoForm onSubmit={onSubmit} />
      </Modal>
      <Modal
        title={
          <h2 style={{ textAlign: "center" }}>Update Employment Status</h2>
        }
        footer={null}
        style={{ top: 100 }}
        width={900}
        className="modalContainer"
        open={updateStatusModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <EmployeeStatus onSubmit={onSubmit} />
      </Modal>

      <Modal
        title={<h2 style={{ textAlign: "center" }}>Update Employee Status</h2>}
        footer={null}
        style={{ top: 100 }}
        width={900}
        className="modalContainer"
        open={suspendFormModal}
        onOk={handleOk}
        onCancel={handleSuspendStatusUpdate}
      >
        <SuspendEmployee onSubmit={onSubmit} />
      </Modal>
    </>
  );
};

export default observer(EmployeeCards);
